export const calculateAdditionalData = (data) =>
  data
    .sort((a, b) => b.yearly_income_family - a.yearly_income_family)
    .map((row, index) => ({
      ...row,
      rank: index + 1,
    }));

export const addAdditionalColumns = (columns = [], currencyFormatter) => [
  {
    name: "#",
    accessor: "rank",
  },
  ...columns,
  {
    name: "Monthly Rental for a Single Person",
    accessor: "monthly_rental_single",
    formatter: currencyFormatter,
  },
  {
    name: "Annual Income Needed for Single Person",
    accessor: "yearly_income_single",
    formatter: currencyFormatter,
  },
  {
    name: "Monthly Rental for a Family",
    accessor: "monthly_rental_family",
    formatter: currencyFormatter,
  },
  {
    name: "Annual Income Needed for Family",
    accessor: "yearly_income_family",
    formatter: currencyFormatter,
  },
];
